// extracted by mini-css-extract-plugin
export default {"exceptionContainer":"gboZem71GPNZdkHIdhlK","exceptionContent":"dIbJG5A1En0SI8hjHLgh","description":"mIXNFiLJvO1sSI0rGBxk"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"exceptionContainer\":\"gboZem71GPNZdkHIdhlK\",\"exceptionContent\":\"dIbJG5A1En0SI8hjHLgh\",\"description\":\"mIXNFiLJvO1sSI0rGBxk\"}";
        // 1768374542182
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  